import React from 'react';
import { useState } from 'react';
import FileCopyTwoToneIcon from '@material-ui/icons/FileCopyTwoTone';
import CheckIcon from '@material-ui/icons/Check';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { errorApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    transition: theme.transitions.create('text-decoration', {
      duration: theme.transitions.duration.short,
    }),
  },
  text: {
    wordBreak: 'break-all',
    whiteSpace: 'normal',
    transition: theme.transitions.create('text-decoration', {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  iconButton: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
}));

interface CopyableTextProps {
  value: string;
  className?: string;
}

export const CopyableText: React.FC<CopyableTextProps> = ({
  value,
  className,
}) => {
  const [copied, setCopied] = useState(false);
  const errorApi = useApi(errorApiRef);
  const classes = useStyles();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      errorApi.post({
        message: 'Failed to copy to clipboard',
        name: 'Error',
      });
    }
  };

  return (
    <Box className={`${classes.root} ${className}`} onClick={handleCopy}>
      <span className={classes.text}>{value}</span>
      <IconButton
        className={classes.iconButton}
        size="small"
        onClick={e => {
          e.stopPropagation();
          handleCopy();
        }}
        aria-label="Copy to clipboard"
      >
        {copied ? (
          <CheckIcon style={{ color: '#4caf50', fontSize: '1rem' }} />
        ) : (
          <FileCopyTwoToneIcon style={{ fontSize: '1rem' }} />
        )}
      </IconButton>
    </Box>
  );
};
